import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Button,
  Stack,
  Switch,
  FormControlLabel,
  IconButton,
  Tooltip,
} from "@mui/material";
import {
  tlmPostNewDeviceNote,
  tlmGetDeviceNote,
} from "layouts/dashboard/apiService";
import PushPinOutlinedIcon from "@mui/icons-material/PushPinOutlined";
import PushPinIcon from "@mui/icons-material/PushPin";
import { APIStatusDialog } from "components/APIStatusDialog";
import { I18n } from "aws-amplify/utils";
import { useRefresh } from "layouts/dashboard/RefreshContext";

export const AddNewDeviceNoteDialog = ({
  open,
  onClose,
  accountNumber,
  dispatchDevicePlant,
  startDate,
  endDate,
  alarmTypeId,
  originalEquipment,
}) => {
  const [note, setNote] = useState("");
  const [apiStatus, setApiStatus] = useState({
    open: false,
    status: "",
    message: "",
  });
  const { handleRefresh } = useRefresh();

  // Resetta i campi ogni volta che il pop-up viene aperto
  useEffect(() => {
    if (open) {
      setNote("");
    }
  }, [open]);

  const handleSaveNote = async () => {
    try {
      setApiStatus({
        open: true,
        status: "pending",
        message: I18n.get("Adding Device Note"),
      });

      const restOperation = await tlmPostNewDeviceNote(
        accountNumber,
        alarmTypeId,
        originalEquipment,
        note
      );
      const response = await restOperation.response;
      if (response.statusCode === 200) {
        setApiStatus({
          open: true,
          status: "success",
          message: I18n.get("Added Device Note successfully"),
        });

        const response = await tlmGetDeviceNote(
          accountNumber,
          endDate,
          startDate
        );
        dispatchDevicePlant({ type: "DATA_RECEIVED", value: response });
      } else {
        setApiStatus({
          open: true,
          status: "error",
          message: I18n.get("Error adding device note"),
        });
      }
      setTimeout(() => {
        setApiStatus((prevState) => ({ ...prevState, open: false }));
      }, 2000);
      onClose();
      handleRefresh();
    } catch (error) {
      setApiStatus({
        open: true,
        status: "error",
        message: I18n.get("Error adding device note"),
      });

      setTimeout(() => {
        setApiStatus((prevState) => ({ ...prevState, open: false }));
      }, 2000);
      onClose();
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{I18n.get("Add a New Device Note")}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label={I18n.get("Note")}
          fullWidth
          multiline
          rows={2}
          value={note}
          onChange={(e) => setNote(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          {I18n.get("Cancel")}
        </Button>
        <Button onClick={handleSaveNote} color="primary">
          {I18n.get("Save")}
        </Button>
      </DialogActions>
      <APIStatusDialog
        open={apiStatus.open}
        status={apiStatus.status}
        message={apiStatus.message}
      />
    </Dialog>
  );
};
